import React, {Component} from 'react';
import {Row, Col, Tabs, Tab} from "react-bootstrap";
import {Link} from "react-router-dom";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";


export default class DashboardPowiadomienieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }


    componentDidMount() {

    }

    renderPojedynczyWiersz(item){
        if(this.props.czyPromocje){
            return(
                <div className={'powiadomienie-alert'}>
                    <Row>
                        <Col xs={10} lg={10}>
                            <i className={'fa fa-info-circle'} style={{color: 'grey'}}></i>
                            <h5>Promocja na odcinku <label>{item.naz_mi_od} <i className={'fa fa-long-arrow-right'} style={{margin: '0 3px'}}></i> {item.naz_mi_do}</label>, od {item.data_od+' '+DateAndTimeFormat.formatHHMM(item.godz_od)} do {item.data_do+' '+DateAndTimeFormat.formatHHMM(item.godz_do)} </h5>
                        </Col>
                        <Col xs={2} lg={2}>
                            <div className={'pull-right'}>
                                <Link to={this.props.url} target={'_blank'}><i className={'fa fa-external-link'}
                                                             title={'Zobacz'}></i></Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }else{
            return(
                <div className={'powiadomienie-alert'}>
                    <Row>
                        <Col xs={10} lg={10}>
                            <i className={'fa fa-exclamation-circle'} style={{color: item.typ===1?'firebrick':'orange'}}></i>
                            <h5><label>{item[this.props.typ]} - </label> {item.uwaga} </h5>
                        </Col>
                        <Col xs={2} lg={2}>
                            <div className={'pull-right'}>
                                <Link to={this.props.url}><i className={'fa fa-external-link'}
                                                             title={'Zobacz'}></i></Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }

    }

    render() {

        return (
            <div className={'powiadomienie-container'}>
                <div className={'heading_name'}>
                    {this.props.tytul}
                    <small>{this.props.podtytul} ({this.props.dane.length} rekordów)</small>
                </div>
                <div className={'thumbnail'}>
                    {
                        this.props.dane.map(item=>{
                            return this.renderPojedynczyWiersz(item)
                        })
                    }
                    {
                        this.props.dane.length === 0?
                            <div style={{color:'#aaa', fontStyle:'italic'}}>Brak trwających promocji</div>
                            :
                            ''
                    }
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/dashboard/components/DashboardPowiadomienieContainer.js